<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-4.col-3.mb-1
        DateRangePicker(:value="dateRange" @update="getData" :key="key")
      .form-group.col-6.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getReviewList(true)"
          variant="primary"
          size="sm"
        )

  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th(width="3%")
                  span #
                th.sortable(width="8%" @click="sortOrder('member_id')")
                  span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                  .float-right
                    i(:class="changeSortKey('member_id')")
                th(width="23%")
                  span(:title="$t('ui.comment')") {{ $t('ui.comment') }}
                th(width="23%")
                  span(:title="$t('ui.reply')") {{ $t('ui.reply') }}
                //- th(width="7%")
                //-   span(:title="$t('ui.recipient_no')") {{ $t('ui.recipient_no') }}
                th.text-center(width="10%")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th(width="8%")
                  span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
                th.text-right(width="9%")
                  span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                th.text-right.sortable(width="9%" @click="sortOrder('created_date')")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  .float-right
                    i(:class="changeSortKey('created_date')")
            tbody.clusterize-content
              tr(v-if="reviewList.length == 0")
                td(:colspan="8").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in reviewList")
                td
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.member_id") {{ item.member_id }}
                td
                  span(:title="item.comment") {{ item.comment }}
                td
                  span(:title="item.reply") {{ item.reply }}
                //- td
                //-   span(:title="item.recipient_no") {{ item.recipient_no }}
                td.text-center
                  span(v-if="isEditAccess")
                    a.fa.fa-reply.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onReply(item)" :title="$t('ui.reply')" v-if="canReply")
                  span.ml-1
                    a.fa.fa-star.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="onReviewDetail(item)" :title="$t('ui.review_detail')")
                  span.ml-1
                    a.fa.fa-search.btn.btn-ssm.btn-secondary(href="javascript:void(0)" @click="onTicketDetail(item)" :title="$t('ui.ticket_detail')")
                td
                  span(:title="item.modified_by") {{ item.modified_by }}
                td.text-right
                  span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.modified_date") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    ticketdetail(ref="ticketdetail" :ticketId="selectedTicketId" @failed="handleFailed")
    reviewdetail(ref="reviewdetail" :item="selectedReview" @failed="handleFailed")
    reviewreply(ref="reviewreply" :item="selectedReview" @clicked="afterReply" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import ticketdetail from "@/components/ticket/ticketDetail.vue";
import reviewdetail from "@/components/review/reviewDetail.vue";
import reviewreply from "@/components/review/reviewReply.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    ticketdetail,
    reviewdetail,
    reviewreply
  },
  data: () => ({
    loading: false,
    reviewList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    dateRange: {
      startDate: null,
      endDate: null
    },
    selectedTicketId: null,
    selectedReviewId: null,
    selectedReview: null,
    sortKey: "created_date",
    sortType: "desc",
    key: 1
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_review");
    },
    canReply() {
      return true;
    }
  },
  mounted: function() {
  },
  methods: {
    refresh() {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      // Refresh the Date picker if change tab and change back
      this.$nextTick(() => {
        this.key += 1
      });
      this.getReviewList(true);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getReviewList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getReviewList(true);
    },
    getReviewList: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.reviewListUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.reviewList = response.data.dt;
                  this.totalRow = this.reviewList.length > 0 ? this.reviewList[0].totalrows : 0;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.reviewList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    onTicketDetail: function(e) {
      this.selectedTicketId = e.ticket_id;
      this.$refs.ticketdetail.$refs.ticketDetail.show();
    },
    onReviewDetail: function(e) {
      this.selectedReview = e;
      this.$refs.reviewdetail.$refs.reviewDetail.show();
    },
    onReply: function (e) {
      this.selectedReview = e;
      this.$refs.reviewreply.$refs.reviewReply.show();
    },
    afterReply: function() {
      this.getReviewList();
      this.$helpers.showDialog(this.$t("ui.reply_review"), this.$t("message.success"), "success");
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getReviewList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getReviewList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>